export default class ImageManager extends HTMLElement {
  private intersectionObserver: IntersectionObserver | null = null;
  private image: HTMLImageElement | null = null;

  private onIntersectionBound = this.onIntersection.bind(this);

  connectedCallback(): void {
    this.image = this.querySelector('[data-image-manager-ref="image"]');

    this.addEventListeners();
  }

  addEventListeners(): void {
    if (this.image && this.image.classList.contains('opacity-0')) {
      this.intersectionObserver = new IntersectionObserver(this.onIntersectionBound, {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
      });

      this.intersectionObserver.observe(this.image);
    }
  }

  removeEventListeners(): void {
    if (this.image) {
      this.intersectionObserver?.disconnect();
      this.image.removeEventListener('load', this.onImageLoad);
    }
  }

  onIntersection(entries: IntersectionObserverEntry[]): void {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (this.image) {
          if (this.image.complete) {
            this.onImageLoad();
          } else {
            this.image.addEventListener('load', () => {
              this.onImageLoad();
            });
          }
        }
      }
    });
  }

  onImageLoad(): void {
    if (this.image) {
      this.image.classList.remove('opacity-0');
    }
  }

  disconnectedCallback(): void {
    this.removeEventListeners();
  }
}

customElements.define('image-manager', ImageManager);
